module.exports = __webpack_public_path__ + "cobblestone_museum.78f70b1508df8652b53b3de725c881fb.png";